import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  active: null,
  nextActive: null,
  illustrations: [],
  templates: [],
  illustrationsSearchTags: [],
};

export const boardMenuSlice = createSlice({
  name: 'board-menu',
  initialState: { ...initialState },
  reducers: {
    reset: () => {
      return { ...initialState };
    },
    open: (state, action) => {
      state.active = action.payload;
      state.nextActive = null;
    },
    close: (state) => {
      state.active = null;
    },
    change: (state, action) => {
      state.nextActive = action.payload;
    },
    updateIllustrations: (state, action) => {
      state.illustrations = action.payload;
    },
    updateTemplates: (state, action) => {
      state.templates = action.payload;
    },
    setIllustrationsSearchTags: (state, action) => {
      state.illustrationsSearchTags = action.payload;
    },
  },
});

export const {
  reset,
  open,
  close,
  change,
  updateIllustrations,
  updateTemplates,
  setIllustrationsSearchTags,
} = boardMenuSlice.actions;

export default boardMenuSlice.reducer;
